export default "__VITE_ASSET__q1Vk9T$U__"